import { cn } from "@/lib/cn";

export function BrandMark({ className }: { className?: string }) {
  return (
    <span className={cn("inline-flex items-center gap-2.5", className)}>
      <img
        src="/logo.png"
        alt=""
        width={28}
        height={28}
        className="rounded object-contain"
      />
      <span className="font-semibold text-navy-900 leading-none">
        AI&nbsp;Logistics
      </span>
    </span>
  );
}
